// export enum FeaturesList {
//     TRENDING_DATA = 'Trending Data'
// }

export enum DataEditorFeaturesList {
    DATA_EDITOR_UPLOAD = 'UPLOAD_DATA',
    PREVIEW_DATA = 'PREVIEW_DATA',
    MAP_DATA_TO_MASTER_DATA = 'MAP_DATA_TO_MASTER_DATA'
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace MasterDataFeaturesList {
    export enum MasterData {
        MAP_TO_GBBPUBLIC = 'MAP_TO_GBBPUBLIC',
        ARCHIVE_MASTER_DATA = 'ARCHIVE_FUNCTIONALITY_OF_MASTER_DATA',
        ARCHIVED_ITEMS = 'ARCHIVED_ITEMS',
        RESTORE_ARCHIVED_ITEMS = 'RESTORE_ARCHIVED_ITEMS',
        DELETE_ARCHIVED_ITEMS = 'DELETE_ARCHIVED_ITEMS',
        EXPORT_DATA_SET = 'EXPORT_DATA_SET'
    }

    export enum Category {
        ADD_CATEGORY = 'ADD_CATEGORY',
        EDIT_CATEGORY = 'EDIT_CATEGORY',
        ARCHIVE_CATEGORY = 'ARCHIVE_CATEGORY',
        DELETE_CATEGORY = 'DELETE_CATEGORY',
        CLONE_CATEGORY = 'CLONE_CATEGORY',
        EXPORT_CATEGORY = 'EXPORT_CATEGORY'
    }

    export enum SubCategory {
        ADD_SUB_CATEGORY = 'ADD_SUB_CATEGORY',
        EDIT_SUB_CATEGORY = 'EDIT_SUB_CATEGORY',
        DELETE_SUB_CATEGORY = 'DELETE_SUB_CATEGORY',
        MOVE_SUB_CATEGORY = 'MOVE_SUB_CATEGORY',
        ARCHIVE_SUB_CATEGORY = 'ARCHIVE_SUB_CATEGORY',
        CLONE_SUB_CATEGORY = 'CLONE_SUB_CATEGORY',
        EXPORT_SUB_CATEGORY = 'EXPORT_SUB_CATEGORY'
    }
    export enum Indicator {
        ADD_INDICATOR = 'ADD_INDICATOR',
        EDIT_INDICATOR = 'EDIT_INDICATOR',
        LINK_INDICATOR = 'LINK_INDICATOR',
        COPY_INDICATOR = 'COPY_INDICATOR',
        DELETE_INDICATOR = 'DELETE_INDICATOR',
        MOVE_INDICATOR = 'MOVE_INDICATOR',
        ARCHIVE_INDICATOR = 'ARCHIVE_INDICATOR',
        EXPORT_INDICATOR = 'EXPORT_INDICATOR'
    }
}

export enum ConfigurationFeaturesList {
    SET_UP_TRENDING_DATA = 'SET_UP_TRENDING DATA',

    SET_UP_FREQUENTLY_USED = 'SET_UP_FREQUENTLY_USED',

    SET_UP_STATIC_INDICATOR = 'SET_UP_STATIC_INDICATOR',

    SET_UP_GEOGRAPHY_OVERVIEW = 'SET_UP_GEOGRAPHY_OVERVIEW',

    SET_UP_KEY_INDICATOR = 'SET_UP_KEY_INDICATOR',

    SET_UP_WHATSNEW = 'SET_UP_WHATSNEW',

    SET_UP_VIDEO_LINK = 'SET_UP_BRIGHTCOVE_VIDEO_LINK'
}

export enum DataManagementFeaturesList {
    SET_UP_INDICATOR_SOURCE = 'SET_UP_INDICATOR_SOURCES',
    SET_UP_COMPANY_FOOTPRINT = 'SET_UP/CHANGE_PRESENCE_(UPDATE)'
}

export enum AdminRoleManagementFeaturesList {
    SET_UP_ROLES_FEATURES = 'SET_UP_ROLES_FEATURES',
    SET_UP_USER_PERMISSION = 'SET_UP_USER_PERMISSION'
}

export enum StatusTrackingFeaturesList {
    UPLOAD_HISTORY = 'UPLOAD_HISTORY',
    SYNC_HISTORY = 'SYNC_HISTORY'
}
